<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
    
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <div *ngIf="!submitted">
          <h1 class="mat-headline-2" i18n>Help us improve</h1>
          <h2 i18n>Let us know if you have any comments about the solution, ideas for future development or if there is something really important missing for you. </h2>
          <form [formGroup]="contactForm" (ngSubmit)="submit()">
            <mat-form-field [style.width.%]=100>
              <textarea matInput formControlName="message" rows="10" required></textarea>
              <mat-hint align="end">{{contactForm.controls['message'].value?.length || 0}} / 1000</mat-hint>
            </mat-form-field>
            <button 
              mat-raised-button 
              type="submit" 
              color="accent" 
              [disabled]="!contactForm.valid"
              i18n="send feedback button label">
              SEND
            </button>
          </form>
        </div>
        <div *ngIf="submitted">
          <h1 class="mat-headline-2" i18n>Thank you for your feedback!</h1>
        </div>
      </div>
    </div>
  </div>
</div>